
import * as constants from "../../../../constants";
import environment from "../../../../environments/environment";
import { notifyUser } from "../../Utils/notifyUser";
import { axiosInterceptor } from "../authInterceptor";

const SAVE_PARTICIPANT = environment.postSaveNewParticipant;
const DELETE_PARTICIPANT_ID = environment.postSaveNewParticipant;

export async function addNewParticipant(participantData: any) {
  try {
    const response = await axiosInterceptor.post(`${SAVE_PARTICIPANT}/`, participantData);
    return response;
  } catch (error: any) {
    notifyUser(error.response.data.message, 'error', "Participant");
  }
}

export async function deleteByParticipantId(pId: any, cId: any) {
  try {
    const response = await axiosInterceptor.delete(`${DELETE_PARTICIPANT_ID}/${pId}?clientId=${cId}`);
    return response;
  } catch (error: any) {
    if (error.status === constants.STATUS_CODES.NOT_FOUND) {
      notifyUser(error.response.data.message, 'error', "Participant");
    } else {
      notifyUser(error.message, 'error', "Participant");
    }
  }
}

export async function getByParticipantIdLogo(pId: any, cId: any) {
  try {
    const response = await axiosInterceptor.get(`${DELETE_PARTICIPANT_ID}/${pId}/logo?clientId=${cId}`);
    return response;
  } catch (error: any) {
    return error
  }
}

export async function deleteByParticipantIdLogo(pId: any, cId: any) {
  try {
    const response = await axiosInterceptor.delete(`${DELETE_PARTICIPANT_ID}/${pId}/logo?clientId=${cId}`);
    return response;
  } catch (error: any) {
    return error
  }
}

export async function saveLogo(saveLogo: FormData, pId: any) {
  try {
    const response = await axiosInterceptor.put(`${DELETE_PARTICIPANT_ID}/${pId}/logo`, saveLogo);
    return response;
  } catch (error) {
    console.error('There was an error saving the theme setting!', error);
    throw error;
  }
}
